var HomepageHeader = function () {
  var init = function () {
    $(document).ready(function () {

      function clickOutside(query) {
        $(document).click(function (event) {
          if (!$(event.target).parents(query).length &&
            $(query).hasClass('open')) {
            $(query).removeClass('open')
          }
        });
      }

      //logo
      $('#headerLogo').click(function (event) {
        if (window.location.pathname === '/sluzba') {
          $('html,body').animate({scrollTop: 0}, 500)
          event.preventDefault()
        }
      })

      // i18n button
      $("#i18n-button__holder").click(function (event) {
        event.stopPropagation()
        $('.i18n-button').toggleClass('open')
        $('#iconSubmenu').removeClass('open')
        $('.ul-header__search-holder').removeClass('open')
        $('.o-header__user-container').removeClass('open')
        $('.o-header__user-wrapper__menu').removeClass('shown')
      })

      clickOutside('.i18n-button')

      //search
      $('#searchIcon').click(function (event) {
        event.stopPropagation()
        $('.ul-header__search-holder').toggleClass('open')
        $('.i18n-button').removeClass('open')
        $('#iconSubmenu').removeClass('open')
        $('#mobileMenu').removeClass('open')
        $('#iconMenu .menu').removeClass('d-none')
        $('#iconMenu .cross').addClass('d-none')
        $('.o-header__user-container').removeClass('open')
        $('.o-header__user-wrapper__menu').removeClass('shown')
        setTimeout(function () {
          $('.ul-header__search-holder.open input').focus()
        }, 250)
      })

      clickOutside('.ul-header__search-holder')

      $('.ul-header__search-holder input').on('keyup', function (e) {
        e.preventDefault()
        if (e.key === 'Enter' || e.keyCode === 13) {
          window.location.href = '/vyhledavani-u-lekare?search=' + $('.ul-header__search-holder input').val()
        }
      });

      //navigation

      $('#whatWeDo').click(function (event) {
        event.preventDefault()
      })

      function clearMenu() {
        setTimeout(function () {
          $('#mobileMenu').scrollTop('0')
          $('#mobileNext').removeClass('open')
          $('#mobileWhatWeDo').removeClass('open')
        }, 260)
      }

      $('#iconMenu').click(function (event) {
        event.stopPropagation();
        if ($('#menuDesktop').is(':visible')) {
          $('#iconSubmenu').toggleClass('open')
          $('.i18n-button').removeClass('open')
          $('.ul-header__search-holder').removeClass('open')
          $('.o-header__user-container').removeClass('open')
          $('.o-header__user-wrapper__menu').removeClass('shown')
        } else {
          if ($('#mobileMenu').hasClass('open')) {
            clearMenu()
          }
          $('#mobileMenu').toggleClass('open')
          $('#iconMenu .menu').toggleClass('d-none')
          $('#iconMenu .cross').toggleClass('d-none')
          $('.ul-header__search-holder').removeClass('open')
        }
      })

      clickOutside('#iconSubmenu')

      $('#mobileNext').click(function (event) {
        $('#mobileNext').toggleClass('open')
      })

      $('#mobileWhatWeDo').click(function (event) {
        $('#mobileWhatWeDo').toggleClass('open')
      })

      $('#mobileMenu a').click(function () {
        if ($(this).attr("href").indexOf('/#') === 0) {
          clearMenu()
          $('#mobileMenu').removeClass('open')
          $('#iconMenu .menu').removeClass('d-none')
          $('#iconMenu .cross').addClass('d-none')
        }
      })

    });
  }

  return {
    init: init
  }
}()

UL.register(HomepageHeader)
